let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cRI4j")).then(() => parcelRequire('gu7rl'));